import { render } from "./DayPicks.vue?vue&type=template&id=65ee45ac"
import script from "./DayPicks.vue?vue&type=script&lang=ts"
export * from "./DayPicks.vue?vue&type=script&lang=ts"
script.render = render

export default script